import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

// appkey:qyzx7560fc504cb6803b280dd5784dee
// 定义接口返回的数据结构
interface ApiResponse<T = any> {
  code: number;
  msg: string;
  data: T;
}

class HttpClient {
  private instance: AxiosInstance;

  constructor (baseURL: string) {
    this.instance = axios.create({
      baseURL,
      timeout: 10000, // 请求超时时间
      headers: {
        'Content-Type': 'application/json'
      }
    })

    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        // 在发送请求之前可以做一些处理，比如添加 token
        const token = localStorage.getItem('token')
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    // 响应拦截器
    this.instance.interceptors.response.use(
      (response: AxiosResponse<ApiResponse>) => {
        // 对响应数据做一些处理
        if (response.data.code !== 200) {
          console.error('请求失败:', response.data.msg)
          return Promise.reject(response.data.msg)
        }
        return response.data.data // 直接返回实际数据
      },
      (error) => {
        // 对错误响应做一些处理
        console.error('请求出错:', error.msg)
        return Promise.reject(error)
      }
    )
  }

  // 封装 GET 请求
  public async get<T> (url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.get(url, config)
  }

  // 封装 POST 请求
  public async post<T> (url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.post(url, data, config)
  }

  // 封装 PUT 请求
  public async put<T> (url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.put(url, data, config)
  }

  // 封装 DELETE 请求
  public async delete<T> (url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.delete(url, config)
  }
}

// 创建实例并导出
const baseURL = 'https://mgread-api.17xiudou.cn' // 替换为你的 API 地址
const http = new HttpClient(baseURL)

export default http
